import { Card, FC, useNavigate } from 'external/react'
import useParent from 'context/parent-context/hook'
import PaymentItem from './PaymentItem'
import ShowPaymentDetail from './modals/ShowPaymentDetail'
import { notifySuccess, notifyWarning, showConfirmCancelSubscription } from 'components/Notify'
import { paymentService } from 'services/payment.service'
import ChangePaymentMethod from './modals/ChangePaymentMethod'

const PaymentPage:FC = () => {

    const {update, state: {payments}} = useParent()
    const navigate = useNavigate()

    function handleModalEvent(indexProp: 'paymentDetailIndex' | 'changePaymentMethodIndex', index:false|number) {
        update({[indexProp]: {$set: index}})
    }

    async function handleItemAction(index, status){
       const subscription = payments.items[index]
       switch (status) {
          case 'active':
            const {isConfirmed: cancelationConfirmed} = await showConfirmCancelSubscription(subscription.subscriptionEnds || new Date())
            if (cancelationConfirmed) {
              const response = await paymentService.cancelSubscription(subscription);
			  notifyWarning(`Tu suscripción: Plan ${subscription.offerName} ha sido cancelada.`)
              update({payments: {refreshes: {$apply: i => i + 1}}})
            }
            break;
          case 'pending': 
            await paymentService.reactiveSubscription(subscription);
            notifySuccess(`Tu suscripción Plan ${subscription.offerName} ha sido reactivada.`);
            update({payments: {refreshes: {$apply: i => i + 1}}})
            break;
          case 'past_due':
              navigate(`/home/payment/history?subscription=${subscription.subscription}`)
              break;
          default:
            console.log(`unhandled: ${subscription}`)
            break;
       }
    }


	return (
        <Card.Body className='mt-2'>
            <div className='row'>
                {payments.items.map((p, i) => <PaymentItem
                    key={i}
                    index={i}
                    handleOpenDetail={i => handleModalEvent('paymentDetailIndex', i)}
                    handleChangePaymentMethod = {i => handleModalEvent('changePaymentMethodIndex', i)}
                    handleItemAction={handleItemAction}
                    payment={p}/>
                )}
            </div>
            <ShowPaymentDetail handleClose={() => handleModalEvent('paymentDetailIndex', false)}/>
            <ChangePaymentMethod handleClose={() => handleModalEvent('changePaymentMethodIndex', false)} />
        </Card.Body>
	)
}

export {PaymentPage as default}